import React, { useState, useEffect } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Badge,
} from "reactstrap"
import axios from "axios"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"

const AssignUsersModal = ({
  modal_standard,
  setmodal_standard,
  selectedGroup,
  getAllGroups,
}) => {
  const [availableUsers, setAvailableUsers] = useState([])
  const [assignedUsers, setAssignedUsers] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    if (modal_standard && selectedGroup) {
      fetchAvailableUsers()
      fetchGroupDetails()
    }
  }, [modal_standard, selectedGroup])

  const fetchAvailableUsers = () => {
    setLoadingUsers(true)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups/users/available`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setLoadingUsers(false)
        if (res.data.success) {
          setAvailableUsers(res.data.data)
        } else {
          toast.error("Failed to fetch users", {
            position: "top-center",
            autoClose: 3000,
          })
        }
      })
      .catch(err => {
        setLoadingUsers(false)
        toast.error("Failed to fetch users", {
          position: "top-center",
          autoClose: 3000,
        })
      })
  }

  const fetchGroupDetails = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups/${selectedGroup.id}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.success) {
          setAssignedUsers(res.data.data.users || [])
        }
      })
      .catch(err => {
        console.error("Failed to fetch group details")
      })
  }

  const handleUserSelection = userId => {
    setSelectedUsers(prev => {
      if (prev.includes(userId)) {
        return prev.filter(id => id !== userId)
      } else {
        return [...prev, userId]
      }
    })
  }

  const assignUsers = () => {
    if (selectedUsers.length === 0) {
      toast.warning("Please select users to assign", {
        position: "top-center",
        autoClose: 3000,
      })
      return
    }

    setLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups/${selectedGroup.id}/assign-users`,
        {
          user_ids: selectedUsers,
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setLoading(false)
        if (res.data.success) {
          toast.success("Users assigned successfully", {
            position: "top-center",
            autoClose: 3000,
          })
          setSelectedUsers([])
          fetchGroupDetails()
          getAllGroups()
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
          })
        }
      })
      .catch(err => {
        setLoading(false)
        toast.error("Failed to assign users", {
          position: "top-center",
          autoClose: 5000,
        })
      })
  }

  const removeUser = userId => {
    if (
      window.confirm(
        "Are you sure you want to remove this user from the group?"
      )
    ) {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
            "company_name"
          )}/groups/${selectedGroup.id}/remove-users`,
          {
            user_ids: [userId],
          },
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${
                getCurrentUser().token == null ? "" : getCurrentUser().token
              }`,
            },
          }
        )
        .then(function (res) {
          if (res.data.success) {
            toast.success("User removed successfully", {
              position: "top-center",
              autoClose: 3000,
            })
            fetchGroupDetails()
            getAllGroups()
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
            })
          }
        })
        .catch(err => {
          toast.error("Failed to remove user", {
            position: "top-center",
            autoClose: 5000,
          })
        })
    }
  }

  const toggleModal = () => {
    setmodal_standard(false)
    setSelectedUsers([])
    setSearchTerm("")
  }

  const filteredUsers = availableUsers.filter(
    user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const unassignedUsers = filteredUsers.filter(
    user => !assignedUsers.some(assignedUser => assignedUser.id === user.id)
  )

  return (
    <Modal isOpen={modal_standard} toggle={toggleModal} size="xl">
      <ModalHeader toggle={toggleModal}>
        Manage Users for "{selectedGroup?.name}"
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <h5>Available Users</h5>
            <FormGroup>
              <Input
                type="text"
                placeholder="Search users..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </FormGroup>

            {loadingUsers ? (
              <div className="text-center">
                <i className="fa fa-spinner fa-spin"></i> Loading users...
              </div>
            ) : (
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                <ListGroup>
                  {unassignedUsers.map(user => (
                    <ListGroupItem
                      key={user.id}
                      className={`d-flex justify-content-between align-items-center ${
                        selectedUsers.includes(user.id) ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleUserSelection(user.id)}
                    >
                      <div>
                        <strong>{user.name}</strong>
                        <br />
                        <small className="text-muted">{user.email}</small>
                        {user.phone && (
                          <>
                            <br />
                            <small className="text-muted">{user.phone}</small>
                          </>
                        )}
                      </div>
                      {selectedUsers.includes(user.id) && (
                        <Badge color="primary">Selected</Badge>
                      )}
                    </ListGroupItem>
                  ))}
                  {unassignedUsers.length === 0 && (
                    <ListGroupItem>
                      <em>No available users found</em>
                    </ListGroupItem>
                  )}
                </ListGroup>
              </div>
            )}

            {selectedUsers.length > 0 && (
              <div className="mt-3">
                <Button
                  color="primary"
                  onClick={assignUsers}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <i className="fa fa-spinner fa-spin me-2"></i>
                      Assigning...
                    </>
                  ) : (
                    `Assign Selected (${selectedUsers.length})`
                  )}
                </Button>
              </div>
            )}
          </Col>

          <Col md={6}>
            <h5>Assigned Users ({assignedUsers.length})</h5>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <ListGroup>
                {assignedUsers.map(user => (
                  <ListGroupItem
                    key={user.id}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <strong>{user.name}</strong>
                      <br />
                      <small className="text-muted">{user.email}</small>
                      {user.phone && (
                        <>
                          <br />
                          <small className="text-muted">{user.phone}</small>
                        </>
                      )}
                    </div>
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => removeUser(user.id)}
                      title="Remove from group"
                    >
                      <i className="fa fa-times"></i>
                    </Button>
                  </ListGroupItem>
                ))}
                {assignedUsers.length === 0 && (
                  <ListGroupItem>
                    <em>No users assigned to this group</em>
                  </ListGroupItem>
                )}
              </ListGroup>
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AssignUsersModal
